
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 180 120"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('g',{attrs:{"id":"d","transform":"translate(0 -36)"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"d":"M0-5v5h3z","fill":"#fff","transform":"rotate(18 0 -5)","id":"a"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-72)"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(144)"}})])]),_c('path',{attrs:{"d":"M0 0h180v120H0z","fill":"#cf142b"}}),_c('path',{attrs:{"d":"M0 0h180v80H0z","fill":"#00247d"}}),_c('path',{attrs:{"d":"M0 0h180v40H0z","fill":"#fc0"}}),_c('g',{attrs:{"transform":"translate(90 84)"}},[_c('g',{attrs:{"id":"f"}},[_c('g',{attrs:{"id":"e"}},[_c('use',{attrs:{"xlink:href":"#d","transform":"rotate(10)"}}),_c('use',{attrs:{"xlink:href":"#d","transform":"rotate(30)"}})]),_c('use',{attrs:{"xlink:href":"#e","transform":"rotate(40)"}})]),_c('use',{attrs:{"xlink:href":"#f","transform":"rotate(-80)"}})])])
          )
        }
      }
    